import { Playbtn } from '../../image';
import styles from './contentvideo.module.scss';
export default function ContentVideo(props) {
  const playVideo = () => {
    const video = document.querySelector(`#${props.id}`);
    const cover = document.querySelector(`.${props.coverClass}`);

    cover.classList.add(`${styles['cover-hidden']}`);
    video.classList.add(`${styles['show-video']}`);
    video.play();
    video.onended = () => {
      cover.classList.remove(`${styles['cover-hidden']}`);
      video.classList.remove(`${styles['show-video']}`);
    };
    video.onpause = () => {
      cover.classList.remove(`${styles['cover-hidden']}`);
      video.currentTime = 0;
      video.classList.remove(`${styles['show-video']}`);
    };
  };
  return (
    <div className={styles['main-content-video']}>
      <div className={`${styles['video-cover']} ${props.coverClass}`}>
        <img src={props.imageCover} alt="" />
        <div className={styles['play-btn']} onClick={playVideo}>
          <Playbtn />
        </div>
      </div>
      <div className={styles['video']}>
        <video src={props.video} alt="" id={props.id}></video>
      </div>
    </div>
  );
}
